import { Injectable } from '@angular/core';

export interface Toast {
  message: string;
  type: 'success' | 'danger' | 'warning' | 'info';
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts: Toast[] = [];

  show(message: string, type: 'success' | 'danger' | 'warning' | 'info' = 'info') {
    this.toasts.push({ message, type });
    setTimeout(() => this.remove(this.toasts[0]), 3000);
  }

  remove(toast: Toast) {
    this.toasts = this.toasts.filter(t => t !== toast);
  }
}